import HeroSection from "./components/HeroSection";
import ProductsSection from "./components/ProductsSection";
import AboutSection from "./components/AboutSection";
import LocationsSection from "./components/LocationsSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <main>
      <HeroSection />
      <ProductsSection />
      <AboutSection />
      <LocationsSection />
      <CTASection />
    </main>
  );
}